import { LoadableLazy } from '@confluence/loadable';

export const StandardUpgradeModalLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-standard-upgrade-modal" */ './StandardUpgradeModal.tsx'
			)
		).StandardUpgradeModal,
});
